import React, { useState } from "react";
import "./FeedbackWindowStyles.css";
import { rateRecommandedAnswer, rateAnswer } from "../../API/api";
import { useLocation } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { useDispatch, useSelector } from "react-redux";
import { message } from "antd";
import { toast } from "react-toastify";

export default function FeedbackWindow({ answerUuid, isSuccess, rating = undefined, isDoc=undefined }) {
  const dispatch = useDispatch();
  const ratingState = useSelector((state) => state.domain);
  const {updateSearchData2} = bindActionCreators(Actions, dispatch);
  const [inputValue, setInputValue] = useState("");
  const [btn, setBtn] = useState(false);
  const [characterCount, setCharacterCount] = useState(200);
  const currentPath = useLocation();
  const getValueFeedback = (e) => {
    setInputValue(e.target.value);
    if (e.target.value.length > 0) {
      setBtn(!btn);
      setCharacterCount(200 - e.target.value.length);
    }
    if (e.target.value.length === 0) {
      setCharacterCount(200);
    }
  };

  const onSubmitFeedbackAction = (message) => {
    return(
      <>
      <span style={{fontSize:'12px'}}>{message}</span>
      </>
    )
  }

  const onSubmitFeedback = () => {
    if(currentPath.pathname.includes('/recommend')){
      const obj = {
        answerUuid: isDoc === undefined ?answerUuid:null,
        docId: isDoc !== undefined ?answerUuid:null,
        feedback: inputValue,
        rating:rating === undefined ?ratingState.ratings[answerUuid].rating:rating
      };
      rateRecommandedAnswer(obj).then((res) => {
        if (res===undefined) return;
        if (res.data.success) {
          isSuccess(res.data.data);
          toast.success(onSubmitFeedbackAction(res.data.message),{position:toast.POSITION.TOP_RIGHT})
        }
      });
    }
    if(currentPath.pathname.includes('/answered')){
      const obj = {
        answerUuid: answerUuid,
        feedback: inputValue,
        rating:rating === undefined ?ratingState.ratings[answerUuid].rating:rating
      };
      rateAnswer(
        obj,
        updateSearchData2,
        ratingState.ratings
      );
    }
  };

  return (
    <div className="feedbackWindow">
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: "3px",
          }}
        >
          <span className="feedbackText">Feedback to the expert</span>
          <span className="characterCount">
            {characterCount} of 200 characters left
          </span>
        </div>
        <div className="row">
          <div className="col-sm-10">
            <textarea
              placeholder="Optional"
              maxLength={200}
              onChange={(e) => getValueFeedback(e)}
              className="feedbackTextArea"
              style={{ width: "100%" }}
            ></textarea>
          </div>
          <div className="col-sm-2">
            <button
              className="btn=primary submitButton"
              disabled={
                inputValue === "" || inputValue.length === 0 ? true : false
              }
              onClick={() => onSubmitFeedback()}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
